import dio, { DioContext, DioType } from './init';

export default {
  completePageAndroidView() {
    dio.track(
      'registration_download_android_page_view',
      DioType.PAGEVIEW,
      {},
      DioContext.REGISTRATION_V2
    );
  },
  completePageIosView() {
    dio.track(
      'registration_download_iPhone_page_view',
      DioType.PAGEVIEW,
      {},
      DioContext.REGISTRATION_V2
    );
  },
  clickDownloadAndroid() {
    dio.track(
      'registration_download_android_click',
      DioType.CLICK,
      {},
      DioContext.REGISTRATION_V2
    );
  },
  clickDownloadIos() {
    dio.track(
      'registration_download_iPhone_click',
      DioType.CLICK,
      {},
      DioContext.REGISTRATION_V2
    );
  },
};
